import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from './material.module';
import { IonicModule } from '@ionic/angular';
import { KeyboardButtonBehaviorDirective } from './directives/keyboard-button-behavior';
@NgModule({
  
  exports: [
    FormsModule,
    TranslateModule,
    MaterialModule,
    IonicModule,
    KeyboardButtonBehaviorDirective
  ],
  declarations: [KeyboardButtonBehaviorDirective]

})
export class SharedModule {}
